import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab, TabList} from "react-tabs";
import { IntegrationSectionDetail } from "./IntegrationSectionDetail";
import { IntegrationSectionHeaders } from "./IntegrationSectionHeaders";
import cx from "classnames";
import styles from './styles.module.scss';
import { IntegrationSectionVideo } from "./IntegrationSectionVideo";
import { IntegrationSectionSubHeader } from "./IntegrationSectionSubHeader";
import _ from "lodash";

export const IntegrationSections = ({ sections, tab, disableScroll}) => {
  const [selectedTab, setSelectedTab] = useState(tab);

  useEffect(() => {
    setSelectedTab(tab);
  }, [tab])

  const icons = {
    "about": "paperflite-info",
    "configuration": "paperflite-settings",
    "demo_video": "paperflite-play",
    "technical_requirements": "paperflite-search-document",
  }

  const handleTabClick = (id) => {
    disableScroll(true);
    setSelectedTab(id);

    const element = document.getElementById(`${id}`);
    const pageContainer = document.getElementById("right");

    if (element) {
        const scrollHeight = element.offsetTop;
        pageContainer.scrollTo({ top: scrollHeight, behavior: "smooth" });

        let isScrolling;

        const scrollHandler = () => {
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(() => {
                disableScroll(false);
                pageContainer.removeEventListener('scroll', scrollHandler);
            }, 100);
        };

        pageContainer.addEventListener('scroll', scrollHandler);
    }
};


  return (
    <div className={styles.sections}
      id="sections"
      >
      <Tabs selectedIndex={selectedTab || 'about'}>
        <TabList>
          {sections.map((section, index) => (
            <Tab key={index}
              className={cx(styles.tab, {
                [styles.activeTab]: section.id === selectedTab
              })}
              onClick={() => handleTabClick(section.id)}
            >
              <div className={cx(styles.circle, {
                [styles.activeCircle]: section.id === selectedTab
              })}>
                <i className={`${icons[section.id]}`}></i>
              </div>
              <span>{section.title}</span>
              <i className={cx("paperflite-right-arrow", styles.rightArrowIcon, {
                [styles.hiderightArrowIcon]: index === sections.length - 1
              })} onClick={(e) => e.stopPropagation()}></i>
            </Tab>
          ))}
        </TabList>

        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.sub_sections.map((sub_section, subSectionIndex) => (
              <div
                key={subSectionIndex}
                id={section.id}
                className={styles.section}
              >
                <IntegrationSectionHeaders header={sub_section.header} />
                <IntegrationSectionSubHeader subHeader={sub_section.sub_header} />
                {section.id === "demo_video" ? (
                  <IntegrationSectionVideo url={sub_section.video} />
                ) : (
                  <IntegrationSectionDetail content={sub_section.content} note={_.get(sub_section, "note", "")}/>
                )}
              </div>
            ))}
          </div>
        ))}

      </Tabs>
    </div>
  );
};